import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';

import { IHome, IHomeDetails } from '../../../utils/interfaces/home';
import { IResponse } from '../../../utils/interfaces/response';
import { HomeService } from '../home.service';

export const getHomeListResolver: ResolveFn<Observable<IResponse<IHome[]>>> = (
  route,
  state
) => {
  const homeService = inject(HomeService);
  return homeService.getDataHome(false, '', 1, 10);
};

export const getHomeDetailsResolver: ResolveFn<
  Observable<IResponse<IHomeDetails>>
> = (route, state) => {
  const homeService = inject(HomeService);
  return homeService.getDataHomeDetails(route.params['id']);
};
